/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import SettingSidebar from "../../components/settingsidebar";
import Widget from "./features/widget";

const Thememanagement = () => {
  return (
    <>
      <Layout>
        <section className="setting_page d_flx align_top">
          <SettingSidebar />
          <Widget />
        </section>
      </Layout>
    </>
  );
};
export default Thememanagement;
